import { Page } from 'layouts/Page';
import { FC } from 'react';
import { ShopifyDevApps } from 'components/ShopifyDevApps';

export const ShopifyDevAppsPage: FC = () => {
	return (
		<Page title="Shopify Dev App – EAS Dashboard">
			<ShopifyDevApps />
		</Page>
	);
};
